// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "a0dadc7b9a79";
export const BUILD_VERSION_NUMBER = 3;
